"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderModeAwareDashboardSidebar = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var componentDefinition_1 = require("../../componentDefinition");
var SidebarConfigurationPanel_1 = require("./SidebarConfigurationPanel");
/**
 * @internal
 */
exports.RenderModeAwareDashboardSidebar = componentDefinition_1.renderModeAware({
    view: function () { return react_1.default.createElement(react_1.default.Fragment, null); },
    edit: SidebarConfigurationPanel_1.SidebarConfigurationPanel,
});
//# sourceMappingURL=RenderModeAwareDashboardSidebar.js.map